// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32yVB","label":"styles_label__2sbQr"};